<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">
    <br>
    <div class="close">
      <mat-slide-toggle labelPosition="before" class="close-toggle" [(ngModel)]="!isOpen" (ngModelChange)="closeShop(isOpen)">
        Cerrar Manualmente
      </mat-slide-toggle>
    </div>

    <section id="header">
      <h1 class="h1Header">INFORMACIÓN DE TU CUENTA</h1>
    </section>

    <form [formGroup]="shopUserForm" (ngSubmit)="saveChanges(shopUserForm.value)">
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input type="text" matInput formControlName="name" required>
              <mat-error *ngIf="shopUserForm.controls['name'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="shopUserForm.controls['name'].hasError('cannotContainSpace')">
                El nombre no puede ser un espacio en blanco
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Email(usuario)</mat-label>
              <input type="email" matInput formControlName="email" required>
              <mat-error *ngIf="shopUserForm.controls['email'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="shopUserForm.controls['email'].hasError('pattern')">
                Debe ingresar un email válido
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="25">
            <mat-form-field appearance="outline">
              <mat-label>Teléfono</mat-label>
              <input matInput formControlName="phone" required>
              <mat-error *ngIf="shopUserForm.controls['phone'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="shopUserForm.controls['phone'].hasError('cannotContainSpace')">
                El teléfono no puede ser un espacio en blanco
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="25">
            <mat-form-field appearance="outline">
              <mat-label>Tipo de comercio</mat-label>
              <mat-select formControlName="storeType" required>
                <mat-option *ngFor="let type of allStoreTypes" [value]="type.id">{{type.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="shopUserForm.controls['storeType'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>

          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Ciudad</mat-label>
              <mat-select formControlName="city" required>
                <mat-option *ngFor="let city of allCities" [value]="city.id">{{city.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="shopUserForm.controls['city'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">

          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Dirección</mat-label>
              <input type="text" matInput formControlName="address" required>
              <mat-error *ngIf="shopUserForm.controls['address'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="shopUserForm.controls['address'].hasError('cannotContainSpace')">
                La dirección no puede ser un espacio en blanco
              </mat-error>
            </mat-form-field>
          </div>

          <div fxFlex="40">
            <mat-form-field appearance="outline">
              <mat-label>Imagen</mat-label>
              <ngx-mat-file-input formControlName="image" accept=".png, .jpg, .jpeg">
              </ngx-mat-file-input>
              <mat-hint>Tamaño recomendado: 600*400</mat-hint>
            </mat-form-field>
          </div>

          <div fxFlex="10" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
            <img class="image-preview" [src]="DsImage" />
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">

          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Slogan</mat-label>
              <input type="text" matInput formControlName="slogan" required>
              <mat-error *ngIf="shopUserForm.controls['slogan'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="shopUserForm.controls['slogan'].hasError('cannotContainSpace')">
                El slogan no puede ser un espacio en blanco
              </mat-error>
            </mat-form-field>
          </div>

          <div fxFlex="40">
            <mat-form-field appearance="outline">
              <mat-label>Logo</mat-label>
              <ngx-mat-file-input formControlName="logo" accept=".png, .jpg, .jpeg">
              </ngx-mat-file-input>
              <mat-hint>Tamaño recomendado: 600*400</mat-hint>
            </mat-form-field>
          </div>

          <div fxFlex="10" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
            <img class="image-preview" [src]="DsLogo" />
          </div>
        </div>
      </mat-card>

      <h3 class="cardHeader">Tiempos, horarios y precios</h3>
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Horario de apertura 1</mat-label>
              <input type="time" matInput formControlName="open1" required>
              <mat-hint>Seleccione 00 si está siempre abierto</mat-hint>
              <mat-error *ngIf="shopUserForm.controls['open1'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Horario de cierre 1</mat-label>
              <input type="time" matInput formControlName="close1" required>
              <mat-hint>Seleccione 00 si está siempre abierto</mat-hint>
              <mat-error *ngIf="shopUserForm.controls['close1'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="shopUserForm.controls['close1'].hasError('timeError')">
                No puede coincidir ni ser menor que la apertura
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Horario de apertura 2</mat-label>
              <input type="time" matInput formControlName="open2">
              <mat-hint>Opcional</mat-hint>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Horario de cierre 2</mat-label>
              <input type="time" matInput formControlName="close2">
              <mat-hint>Opcional</mat-hint>
              <mat-error *ngIf="shopUserForm.controls['close2'].hasError('timeError')">
                No puede coincidir ni ser menor que la apertura
              </mat-error>
              <mat-error *ngIf="shopUserForm.controls['close2'].hasError('openWithoutValue')">
                Debe ingresar un horario de apertura 2
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Tiempo promedio de entrega</mat-label>
              <input type="number" matInput formControlName="deliveryTime" required>
              <mat-error *ngIf="shopUserForm.controls['deliveryTime'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="shopUserForm.controls['deliveryTime'].hasError('min')">
                El valor no puede ser negativo ni 0.
              </mat-error>
              <mat-hint>En minutos</mat-hint>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Costo aproximado por persona</mat-label>
              <input type="number" matInput formControlName="price" required>
              <mat-hint>No incluir signo de moneda</mat-hint>
              <mat-error *ngIf="shopUserForm.controls['price'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="shopUserForm.controls['price'].hasError('min')">
                El valor no puede ser negativo ni 0.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Token de Mercado Pago</mat-label>
              <input type="text" matInput formControlName="tokenMP">
              <mat-error *ngIf="shopUserForm.controls['tokenMP'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Public Key Mercado Pago</mat-label>
              <input type="text" matInput formControlName="publicKeyMP">
              <mat-error *ngIf="shopUserForm.controls['publicKeyMP'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Valor de envío</mat-label>
              <input type="number" matInput formControlName="deliveryValue">
              <mat-error *ngIf="shopUserForm.controls['deliveryValue'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Distancia máxima de entrega</mat-label>
              <input type="number" matInput formControlName="maxDistance">
              <mat-hint>En kilómetros</mat-hint>
              <mat-error *ngIf="shopUserForm.controls['maxDistance'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
      <h3 class="cardHeader">Imágenes adicionales</h3>
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>Seleccionar imágenes</mat-label>
              <ngx-mat-file-input formControlName="additionalImg" accept=".png, .jpg, .jpeg" multiple>
              </ngx-mat-file-input>
              <mat-hint>Para seleccionar múltiples imágenes presione Ctrl</mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">


          <div fxFlex="ImageFlex" fxLayoutAlign="start center" fxLayoutGap="0.5rem" *ngFor="let imageUrl of imagesUrl">
            <img class="image-preview" [src]="imageUrl" />
          </div>
        </div>
      </mat-card>

      <h3 class="cardHeader">Selecciona la ubicación para Google Maps (para la búsqueda de
        cercanía
        de la app)</h3>
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>Ingrese una ubicación</mat-label>
              <input type="text" matInput [options]='options' formControlName="location" ngx-google-places-autocomplete #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)">
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <input type="text" matInput formControlName="latitude" placeholder="Latitud">
            </mat-form-field>
          </div>

          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <input type="text" matInput formControlName="longitude" placeholder="Longitud">
            </mat-form-field>
          </div>
        </div>
      </mat-card>
      <br>
      <div fxLayout="row" fxLayoutAlign="start center">
        <button mat-flat-button type="submit" class="save-changes" [disabled]="shopUserForm.invalid">GUARDAR
          CAMBIOS</button>
        <button routerLink="/shop-home" mat-raised-button class="cancel-changes">CANCELAR</button>
      </div>
    </form>
  </div>
</div>
